/* tslint:disable */
/* eslint-disable */
/**
 * ADMIN-SERVICE - REST API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.1.0-SNAPSHOT
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { MetaDataFromJSON, MetaDataToJSON, } from './MetaData';
import { NetworkListEntryFromJSON, NetworkListEntryToJSON, } from './NetworkListEntry';
import { PageRequestFromJSON, PageRequestToJSON, } from './PageRequest';
/**
 * Check if a given object implements the PagedResponseOfNetworkListEntry interface.
 */
export function instanceOfPagedResponseOfNetworkListEntry(value) {
    var isInstance = true;
    return isInstance;
}
export function PagedResponseOfNetworkListEntryFromJSON(json) {
    return PagedResponseOfNetworkListEntryFromJSONTyped(json, false);
}
export function PagedResponseOfNetworkListEntryFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'numberOfElements': !exists(json, 'numberOfElements') ? undefined : json['numberOfElements'],
        'hasNext': !exists(json, 'hasNext') ? undefined : json['hasNext'],
        'previousPage': !exists(json, 'previousPage') ? undefined : PageRequestFromJSON(json['previousPage']),
        'size': !exists(json, 'size') ? undefined : json['size'],
        'nextPage': !exists(json, 'nextPage') ? undefined : PageRequestFromJSON(json['nextPage']),
        'hasPrevious': !exists(json, 'hasPrevious') ? undefined : json['hasPrevious'],
        'metaData': !exists(json, 'metaData') ? undefined : MetaDataFromJSON(json['metaData']),
        'entries': !exists(json, 'entries') ? undefined : (json['entries'].map(NetworkListEntryFromJSON)),
        'totalElements': !exists(json, 'totalElements') ? undefined : json['totalElements'],
        'page': !exists(json, 'page') ? undefined : json['page']
    };
}
export function PagedResponseOfNetworkListEntryToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'numberOfElements': value.numberOfElements,
        'hasNext': value.hasNext,
        'previousPage': PageRequestToJSON(value.previousPage),
        'size': value.size,
        'nextPage': PageRequestToJSON(value.nextPage),
        'hasPrevious': value.hasPrevious,
        'metaData': MetaDataToJSON(value.metaData),
        'entries': value.entries === undefined ? undefined : (value.entries.map(NetworkListEntryToJSON)),
        'totalElements': value.totalElements,
        'page': value.page
    };
}
